module.exports = __webpack_public_path__ + "img/arrow.5fef7ffd.png";